var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('esign-video-identification',{attrs:{"token":_vm.$store.getters.esignToken,"end-point":_vm.endPoint,"end-point-video":_vm.endPointVideo,"operation-uuid":_vm.$store.getters.operationUuid,"domain-uuid":_vm.$store.getters.domainUuid}})}
var staticRenderFns = []

export { render, staticRenderFns }